import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import PublicationsReportApplicantPresentationModel, {
  TPublicationsReportApplicantPresentationModel
} from "./model/PublicationsReportApplicantPresentationModel";
import { IPublicationsReportRecord } from "../../model/report/PublicationsReportRecord";

export interface TPublicationsReportPresenter extends TLoadingAwarePresenter {
  applicants: TPublicationsReportApplicantPresentationModel[];
}

export interface IPublicationsReportPresenter
  extends TPublicationsReportPresenter,
    TPresentable {
  setApplicants(publicationsReportRecords: IPublicationsReportRecord[]): void;
}

const defaultState: TPublicationsReportPresenter = {
  applicants: [] as TPublicationsReportApplicantPresentationModel[]
};

const PublicationsReportPresenter = withStore<
  IPublicationsReportPresenter,
  TPublicationsReportPresenter
>(({ application, store, loader, translate }): IPublicationsReportPresenter => {
  const _store = store;
  const _application: Application = application;
  const state = _store.getState<TPublicationsReportPresenter>();

  loader.start("publicationsReportLoader");

  const applicantsPresentationModelMapper = (
    publicationsReportRecords: IPublicationsReportRecord[]
  ) => {
    let applicantIds = publicationsReportRecords.map(
      (publicationsReportRecord: IPublicationsReportRecord) =>
        publicationsReportRecord.applicantId
    );
    applicantIds = applicantIds.filter((id, index, self) => {
      return self.indexOf(id) === index;
    });

    let applicants = [] as IPublicationsReportRecord[][];

    applicantIds.forEach((id: number) => {
      let reportRecords = publicationsReportRecords.filter(
        (publicationsReportRecord: IPublicationsReportRecord) => {
          return publicationsReportRecord.applicantId === id;
        }
      );
      applicants.push(reportRecords);
    });

    return applicants.map((applicant) => {
      return PublicationsReportApplicantPresentationModel(applicant);
    });
  };

  const setApplicants = (
    publicationsReportRecords: IPublicationsReportRecord[]
  ) => {
    _store.update({
      applicants: applicantsPresentationModelMapper(publicationsReportRecords)
    });
    loader.stop("publicationsReportLoader");
  };

  return {
    ...state,
    store: _store,
    loader,
    application: _application,
    translate,
    setApplicants
  };
}, defaultState);

export default PublicationsReportPresenter;
